// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function registerLocationReducer(state = [], action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.LOAD_REGISTER_LOCATION_SUCCESS:
            return action.location;
        case types.CREATE_REGISTER_LOCATION_SUCCESS:
            return [...state, Object.assign({}, action.location)];
        case types.UPDATE_REGISTER_LOCATION_SUCCESS:
            return [...state.filter(location => location.registerLocationId != action.location.registerLocationId), Object.assign({}, action.location)];
        case types.GET_REGISTER_LOCATION_SUCCESS:
            return [...state.filter(location => location.registerLocationId != action.location.registerLocationId), Object.assign({}, action.location)];
        case types.DELETE_REGISTER_LOCATION_SUCCESS:
            return [...state.filter(location => location.registerLocationId != action.location)];
        default:
            return state;
    };
};

